let routes = [
  {
    path: 'consent',
    name: 'auth.consent',
    component: () => import('@/views/Auth/Consent'),
  },
  {
    path: 'logout',
    name: 'auth.logout',
    component: () => import('@/views/Auth/Logout'),
  },
  {
    path: 'login',
    component: () => import('@/components/common/RooshRouterView'),
    children: [
      {
        path: '',
        name: 'auth.login.index',
        component: () => import('@/views/Auth/Index'),
      },
      {
        path: ':social',
        name: 'auth.login.social',
        component: () => import('@/views/Auth/Social'),
      },
    ]
  },
  {
    path: 'set/password',
    name: 'auth.password',
    component: () => import('@/views/Auth/Password'),
  },
  {
    path: 'reset/password',
    name: 'auth.password.reset',
    component: () => import('@/views/Auth/PasswordReset'),
  }
];

export default routes;
